<template>
  <label :class="`vue-checkbox-container${disabled ? `-disabled` : ``}`" @click.stop="">
    <span v-if="label" :class="regularFont ? 'label-wrapper regular' : 'label-wrapper'">{{ label }}</span>
    <input :name="name" type="checkbox" :checked="checked" :disabled="disabled" @change="changeHandler" />
    <span :class="'checkmark'"></span>
  </label>
</template>

<script>
  export default {
    name: "CheckBox",
    props: {
      label: {type: String, default: ""},
      regularFont: {type: Boolean, default: false},
      name: {type: String, default: ""},
      disabled: {type: Boolean, default: false},
      checked: {type: Boolean, default: false}
    },
    methods: {
      changeHandler(event) {
        this.$emit("on-change-handler", event.currentTarget.checked)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .vue-checkbox-container,
  .vue-checkbox-container-disabled {
    display: inline-block;
    position: relative;
    padding-left: 18px;
    margin-bottom: 0;
    min-height: 18px;
    min-width: 18px;
    cursor: pointer;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    .label-wrapper {
      font-size: 14px;
      font-weight: 600;
      padding-left: 10px;
      &.regular {
        font-weight: 400;
      }
    }
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }
    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 18px;
      width: 18px;
      background-image: #eee;
      &::after {
        content: "";
        position: absolute;
        background-image: url("../assets/unchecked.svg");
        background-repeat: no-repeat;
        height: 18px;
        width: 18px;
        background-size: contain;
      }
    }
    input:checked ~ .checkmark {
      &::after {
        background-image: url("../assets/checked.svg");
      }
    }
  }
  .vue-checkbox-container-disabled {
    cursor: not-allowed;
    .label-wrapper {
      color: gray;
    }
  }
</style>
